<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
  <div class="container-header-inner">
    <div class="row">
      <div class="col-12">
        <h1 class="title-default">Configurações Gerais de Vendas</h1>
        <p class="welcome-message">
          <button mat-icon-button type="button" (click)="voltar()">
            <mat-icon>arrow_back</mat-icon>
          </button>
          Preferências gerais que valem para todo o módulo de vendas.
        </p>
      </div>
    </div>

    @if (isLoading) {
      <div class="section-container">
        <app-loading-box height="30" width="200" marginTop="0"></app-loading-box>
        <app-loading-box height="22" width="45%" marginTop="16"></app-loading-box>
        <app-loading-box height="22" width="45%" marginTop="12"></app-loading-box>
      </div>
      <div class="section-container mt-4">
        <app-loading-box height="30" width="240" marginTop="0"></app-loading-box>
        <div class="row mt-3 conteudo-secao">
          <div class="col-12 col-md-6"><app-loading-box height="56" width="100%"></app-loading-box></div>
          <div class="col-12 col-md-6"><app-loading-box height="56" width="100%"></app-loading-box></div>
        </div>
        <app-loading-box height="72" width="100%" marginTop="16"></app-loading-box>
        <app-loading-box height="22" width="55%" marginTop="16"></app-loading-box>
        <app-loading-box height="22" width="55%" marginTop="12"></app-loading-box>
      </div>
      <div class="section-container mt-4">
        <app-loading-box height="30" width="250" marginTop="0"></app-loading-box>
        <app-loading-box height="40" width="100%" marginTop="16"></app-loading-box>
      </div>
      <div class="section-container mt-4">
        <app-loading-box height="30" width="200" marginTop="0"></app-loading-box>
        <app-loading-box height="22" width="45%" marginTop="16"></app-loading-box>
        <app-loading-box height="22" width="45%" marginTop="12"></app-loading-box>
      </div>
      <div class="section-container mt-4">
        <app-loading-box height="30" width="260" marginTop="0"></app-loading-box>
        <app-loading-box height="22" width="55%" marginTop="16"></app-loading-box>
        <app-loading-box height="72" width="100%" marginTop="12"></app-loading-box>
      </div>
    } @else {
      <form [formGroup]="form">
        <app-page-scroll-spy [sections]="sections"></app-page-scroll-spy>

        <div class="section-container" id="numeracao">
          <div class="section-title">
            <mat-icon>tag</mat-icon>
            <span>Numeração</span>
          </div>

          <div class="row mt-3 conteudo-secao">
            <div class="col-12">
              <label class="bloco-titulo">Numeração de orçamentos e pedidos de venda</label>
              <mat-radio-group formControlName="idTipoNumeracaoDocumento" class="d-flex flex-column"
                style="gap: 12px">
                @for (t of opcoesTipoNumeracao; track t.idTipoNumeracaoDocumento) {
                <mat-radio-button [value]="t.idTipoNumeracaoDocumento">
                  {{ t.descricao }}
                  @if (t.textoApoio) {
                  <span class="opcao-desc d-block">{{ t.textoApoio }}</span>
                  }
                </mat-radio-button>
                }
              </mat-radio-group>
              <div class="hint-text mt-3">A escolha vale para os dois processos. Documentos já emitidos não são
                renumerados.</div>
            </div>
          </div>
        </div>

        <div class="section-container mt-4" id="descontos-precos">
          <div class="section-title">
            <mat-icon>percent</mat-icon>
            <span>Descontos e preços</span>
          </div>

          <div class="row mt-3 conteudo-secao">
            <div class="col-12 col-md-6">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Desconto máximo nos itens (%)</mat-label>
                <input matInput currencyMask [options]="percentMask" formControlName="descontoMaximoItens">
                <mat-icon matSuffix class="material-symbols-outlined info-icon" [matTooltip]="descontoItensTooltip"
                  matTooltipPosition="above">info</mat-icon>
                @if (form.get('descontoMaximoItens')?.hasError('min') ||
                form.get('descontoMaximoItens')?.hasError('max')) {
                <mat-error>Informe um valor entre 0 e 100.</mat-error>
                }
              </mat-form-field>
              <div class="hint-text">Para não limitar, informe o valor 100.</div>
            </div>

            <div class="col-12 mt-2">
              <app-desconto-maximo-perfil [perfis]="opcoesPerfis" [value]="descontoPerfil" [padraoSecao]="true"
                titulo="Desconto máximo por perfil" [tooltip]="descontoPerfilTooltip"
                textoVazio="Nenhum perfil com desconto específico"
                textoVazioApoio="Sem exceções cadastradas, todos os perfis usam o desconto máximo dos itens."
                (valueChange)="onDescontoPerfilChange($event)">
              </app-desconto-maximo-perfil>
            </div>

            <div class="col-12">
              <div class="bloco-separado">
                <div class="toggle-content">
                  <mat-slide-toggle class="app-toggle-compact" formControlName="isPriorizarMenorPreco">Priorizar
                    menor preço entre listas
                    <mat-icon class="material-symbols-outlined info-icon" [matTooltip]="precedenciaPrecoTooltip"
                      matTooltipPosition="above" matTooltipClass="tooltip-multilinha"
                      (click)="$event.stopPropagation()">info</mat-icon>
                  </mat-slide-toggle>
                  <span class="info-text">Quando o produto está em mais de uma lista vigente, define se o sistema
                    já traz o menor preço automaticamente.</span>
                </div>
              </div>
            </div>

            <div class="col-12">
              <div class="bloco-separado">
                <div class="toggle-content">
                  <mat-slide-toggle class="app-toggle-compact"
                    formControlName="isExibirPrecoListaDescontoItens">Exibir campo preço de lista e desconto nos
                    itens</mat-slide-toggle>
                  <span class="info-text">{{ precoListaApoio }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="section-container mt-4" id="estoques">
          <div class="section-title">
            <mat-icon>inventory_2</mat-icon>
            <span>Estoques</span>
          </div>

          <div class="row mt-3 conteudo-secao">
            <div class="col-12 mb-3">
              <label class="bloco-titulo">Estorno de estoques</label>
              <mat-radio-group
                formControlName="isEstornoEstoqueAutomatico"
                class="d-flex flex-column"
                style="gap: 10px">
                <mat-radio-button [value]="false">Manual</mat-radio-button>
                <mat-radio-button [value]="true">Automático ao cancelar nota fiscal</mat-radio-button>
              </mat-radio-group>
              <div class="hint-text mt-2">Ao excluir a NF, o estorno também será automático.</div>
            </div>

            <div class="col-12">
              <div class="bloco-titulo bloco-titulo-inline">
                <span>Permite estoque negativo</span>
                <mat-icon class="material-symbols-outlined info-icon" [matTooltip]="estoqueNegativoTooltip"
                  matTooltipPosition="above">info</mat-icon>
              </div>
              <mat-radio-group formControlName="idTipoValidacaoEstoqueNegativo" class="d-flex flex-column"
                style="gap: 12px">
                @for (t of opcoesTipoValidacaoEstoqueNegativo; track t.idTipoValidacaoEstoqueNegativo) {
                <mat-radio-button [value]="t.idTipoValidacaoEstoqueNegativo">
                  {{ t.descricao }}
                  @if (t.textoApoio) {
                  <span class="opcao-desc d-block">{{ t.textoApoio }}</span>
                  }
                </mat-radio-button>
                }
              </mat-radio-group>
            </div>
          </div>
        </div>

        <div class="section-container mt-4" id="logistica">
          <div class="section-title">
            <mat-icon>local_shipping</mat-icon>
            <span>Logística</span>
          </div>

          <div class="row mt-3 conteudo-secao">
            <div class="col-12">
              <div class="toggle-content">
                <mat-slide-toggle class="app-toggle-compact" formControlName="isTrabalhaComSeparacao">Trabalha com
                  Separação</mat-slide-toggle>
                <span class="info-text">Habilita a rotina de separação de pedidos e seu acompanhamento no fluxo de
                  vendas.</span>
                <button mat-button type="button" class="btn-section btn-configurar-logistica"
                  [disabled]="!form.get('isTrabalhaComSeparacao')?.value"
                  (click)="abrirConfiguracaoLogistica('/configuracoes/vendas/separacao', 'separação')">
                  <mat-icon class="material-symbols-outlined">settings</mat-icon> Configurar separação
                </button>
              </div>
              <div class="toggle-content">
                <mat-slide-toggle class="app-toggle-compact" formControlName="isTrabalhaComExpedicao">Trabalha com
                  Expedição</mat-slide-toggle>
                <span class="info-text">Habilita a rotina de expedição, com documentos de envio e controle de
                  postagem.</span>
                <button mat-button type="button" class="btn-section btn-configurar-logistica"
                  [disabled]="!form.get('isTrabalhaComExpedicao')?.value"
                  (click)="abrirConfiguracaoLogistica('/configuracoes/vendas/expedicao', 'expedição')">
                  <mat-icon class="material-symbols-outlined">settings</mat-icon> Configurar expedição
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="section-container mt-4" id="condicoes-pagamento">
          <div class="section-title">
            <mat-icon>payments</mat-icon>
            <span>Condições de pagamento</span>
          </div>

          <div class="row mt-3 conteudo-secao">
            <div class="col-12">
              <div class="toggle-content">
                <mat-slide-toggle class="app-toggle-compact" formControlName="isCondicaoPagamentoLivre">Permitir
                  condição de pagamento livre</mat-slide-toggle>
                <span class="info-text">{{ condicaoPagamentoLivreApoio }}</span>
              </div>
            </div>

            <div class="col-12">
              <app-alert-card type="info">
                Vale igualmente para Orçamento e Pedido de Venda, e afeta apenas as formas com parcelamento
                configurável pela empresa (Boleto, Crediário e as formas cadastradas pela empresa, que nascem nesse
                grupo). Não afeta as formas com parcelamento do intermediador de pagamento (Cartão de crédito, Cartão
                de débito, Pix) nem as de pagamento à vista (Dinheiro, Depósito, Vale-troca). As condições são
                cadastradas em Financeiro &gt;&gt; Configurações &gt;&gt; Condições de Pagamento.
              </app-alert-card>
            </div>
          </div>
        </div>
      </form>
    }
  </div>
</div>

<app-footer-action
  [isLoadingSalvar]="isSaving"
  [isSalvarDisabled]="isLoading"
  (cancelar)="voltar()"
  (salvar)="salvar()">
</app-footer-action>
